import { Component, OnInit } from '@angular/core';
import { ErrorText } from 'az-customer-portal-ui';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss'],
    standalone: false
})
export class NotFoundComponent implements OnInit {
  public errorText: ErrorText;

  constructor(
    private location: Location,
    private translateService: TranslateService) { }

  ngOnInit(): void {
    this.translateService.get('error.404.title').subscribe(res => {
      this.errorText = {
        title: res,
        subtitle: this.translateService.instant('error.404.subtitle'),
        button: this.translateService.instant('error.404.button')
        };
    });
  }

  prevPage($event): void {
    this.location.back();
  }
}
